import useSWRMutation from 'swr/mutation'

import { customerApiPost } from '~/utils/api/customer-api'
import getCustomerApiEndpoints from '~/utils/api/get-customer-api-endpoints'

const gr4vyCreditCardsPath = (profileId: string) =>
  getCustomerApiEndpoints().gr4vyCreditCardsPath(profileId)

export const useCreateCreditCard = (profileId: string) =>
  useSWRMutation(gr4vyCreditCardsPath(profileId), customerApiPost)
